import AppleIcon from "../../icons/AppleIcon";
import GoogleIcon from "../../icons/GoogleIcon";

export default function ButtonSecondary({
  text,
  onClick,
  width,
  padding,
  borderColor,
  bgColor,
  color,
  customClass,
  fontsize,
  iconType,
}) {
  return (
    <button
      className={`flex border ${customClass} ${borderColor} ${width} rounded-md ${bgColor} ${color} ${padding}`}
      onClick={onClick}
    >
      {iconType === "apple" && <AppleIcon />}
      {iconType === "google" && <GoogleIcon />}
      <p className={`${fontsize} flex items-center`}>{text}</p>{" "}
      {/* Adăugăm clasele flex și items-center pentru aliniere verticală și orizontală */}
    </button>
  );
}
